import React from 'react';
import { useContent } from '../i18n/LanguageContext';

export default function Features() {
  const c = useContent();
  const f = c.features;
  const ind = c.industries;
  return (
    <section id="fonctionnalites" className="py-14 md:py-20 bg-white">
      <div className="lt-container">
        <div className="max-w-3xl reveal">
          <p className="text-sm font-semibold uppercase tracking-widest text-teal-600">{f.eyebrow}</p>
          <h2 className="mt-3 font-display text-3xl md:text-4xl font-bold text-slate-900 leading-tight">{f.title}</h2>
          <p className="mt-4 text-lg text-slate-600">{f.subtitle}</p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {f.items.map((item, i) => (
            <div key={item.title} className="reveal card-hover group rounded-2xl border border-slate-200 bg-white p-6" style={{ animationDelay: `${(i % 4) * 70}ms` }}>
              <div className="grid place-items-center w-12 h-12 rounded-xl bg-gradient-to-br from-teal-500 to-cyan-500 text-white shadow-lg shadow-teal-600/25">
                <item.icon className="w-6 h-6" />
              </div>
              <h3 className="mt-4 font-display text-base font-semibold text-slate-900">{item.title}</h3>
              <p className="mt-2 text-sm text-slate-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div id="secteurs" className="mt-16">
          <div className="max-w-3xl reveal">
            <p className="text-sm font-semibold uppercase tracking-widest text-teal-600">{ind.eyebrow}</p>
            <h2 className="mt-3 font-display text-3xl md:text-4xl font-bold text-slate-900 leading-tight">{ind.title}</h2>
            <p className="mt-4 text-lg text-slate-600">{ind.subtitle}</p>
          </div>

          <div className="mt-10 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5">
            {ind.items.map((item, i) => (
              <div key={item.name} className="reveal card-hover group relative rounded-2xl overflow-hidden h-56 border border-slate-200" style={{ animationDelay: `${i * 70}ms` }}>
                <img src={item.img} alt={item.name} className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/85 via-slate-900/25 to-transparent" />
                <div className="absolute bottom-0 inset-x-0 p-4">
                  <span className="grid place-items-center w-10 h-10 rounded-xl bg-white/15 backdrop-blur text-white border border-white/20">
                    <item.icon className="w-5 h-5" />
                  </span>
                  <h3 className="mt-2.5 font-display text-lg font-semibold text-white">{item.name}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
